import { render, staticRenderFns } from "./poorresourcedemand.vue?vue&type=template&id=3f48b937"
import script from "./poorresourcedemand.vue?vue&type=script&lang=js"
export * from "./poorresourcedemand.vue?vue&type=script&lang=js"
import style1 from "./poorresourcedemand.vue?vue&type=style&index=1&id=3f48b937&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports